import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { LoginStateResponse } from '../../../../shared/types/routes/auth/v2';

/**
 * Query key for `GET /api/auth/state`. Exported so callers can invalidate the login state after it changes
 * server-side — e.g. once an MFA challenge is issued or a pending social login is completed.
 */
export const getAuthStateQueryKey = () => ['auth-state'];

function fetchAuthState() {
  return get<LoginStateResponse>('/api/auth/state');
}

/**
 * Reads the current login phase from the server on mount: the configured OAuth buttons plus any already-in-progress
 * login state (pending social auth, issued MFA challenge).
 */
export default function useAuthState() {
  return useQuery<LoginStateResponse>({
    queryKey: getAuthStateQueryKey(),
    queryFn: fetchAuthState,
  });
}
